export const cookiePolicyGroups = {
    strict: 'C0001',
    analytical: 'C0002',
    personalisation: 'C0003',
    targeting: 'C0004',
    socialMedia: 'C0005',
  };
  
  export default class CookiePolicy {
    private static checkOneTrustActiveGroups(groupId: string): boolean {
        return (window.OnetrustActiveGroups || "").indexOf(groupId) !== -1;
    }
  
    public static isStrictCookiesEnabled(): boolean {
        return this.checkOneTrustActiveGroups(cookiePolicyGroups.strict);
    }
  
    public static isPersonalisationCookiesEnabled(): boolean {
        return this.checkOneTrustActiveGroups(cookiePolicyGroups.personalisation);
    }
  
    public static isAnalyticalCookiesEnabled(): boolean {
        return this.checkOneTrustActiveGroups(cookiePolicyGroups.analytical);
    }
  
    public static isTargetingCookiesEnabled(): boolean {
        return this.checkOneTrustActiveGroups(cookiePolicyGroups.targeting);
    }
  
    public static isSocialMediaCookiesEnabled(): boolean {
        return this.checkOneTrustActiveGroups(cookiePolicyGroups.socialMedia);
    }
  }
  